<template>
  <div>
    <DataTable
      class="q-mt-md"
      name="acessTokenTable"
      :data="tableData"
      :columns="columns"
      :columnItems="columnItems"
      rowKey="client_id"
      :filter-placeholder="$t('Search token')"
      :loading="loading"
    >
      <template v-slot:body-cell-action="{ props }">
        <Td :props="props">
          <Button
            color="negative"
            icon="delete"
            flat
            @click="openDeleteDialog(props.row.client_id)"
          />
        </Td>
      </template>
    </DataTable>

    <DeleteDialog v-model="deleteDialogVisible" :deleteClientId="deleteClientId" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Button from '@design-system/components/Button';
import DataTable from '@design-system/components/DataTable/DataTable';
import Td from '@design-system/components/DataTable/Td';
import DeleteDialog from './UserClientDialogDelete';

const messages = {
  en: {
    'Search token': 'Search token',
    'Token name': 'Token name',
    'Client ID': 'Client ID',
    'Client Secret': 'Client Secret',
    'Created Date': 'Created Date',
    Action: 'Action',
  },
  ja: {
    'Search token': 'トークンを検索',
    'Token name': 'トークン名',
    'Client ID': 'Client ID',
    'Client Secret': 'Client Secret',
    'Created Date': '作成日',
    Action: 'アクション',
  },
};

export default {
  name: 'UserClients',
  components: { DeleteDialog, DataTable, Td, Button },
  i18n: { messages },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      deleteClientId: '',
    };
  },
  computed: {
    ...mapState('userClients', {
      tableData: state => state.data,
    }),
    columns() {
      return [
        {
          name: 'name',
          label: this.$t('Token name'),
          field: 'name',
          sortable: true,
          align: 'left',
        },
        {
          name: 'client_id',
          label: this.$t('Client ID'),
          field: 'client_id',
          sortable: true,
          align: 'left',
        },
        {
          name: 'create_time',
          label: this.$t('Created Date'),
          field: 'create_time',
          sortable: true,
          align: 'left',
        },
        {
          name: 'action',
          label: '',
          field: 'action',
          align: 'center',
          style: 'width:80px',
        },
      ];
    },
    columnItems() {
      return ['name', 'client_id', 'create_time', 'action'];
    },
  },
  async created() {
    await this.fetchClients();
  },
  methods: {
    ...mapActions('userClients', {
      fetchClients: 'fetchClients',
    }),
    openDeleteDialog(clientId) {
      this.deleteDialogVisible = true;
      this.deleteClientId = clientId;
    },

    filterMethod(rows, filter) {
      if (filter === '') {
        return rows;
      }
      return rows.filter(item => Object.values(item).find(val => String(val).includes(filter)));
    },
    changeSearchQuery(val) {
      this.filter = val;
    },
  },
};
</script>
